import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { ArchwizardModule } from 'angular-archwizard';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';
import { FileUploadModule } from 'ng2-file-upload/ng2-file-upload';

import { FooterComponent } from './footer/footer.component';
import { NavbarComponent } from './navbar/navbar.component';
import { SidebarComponent } from './sidebar/sidebar.component';
import { ToggleFullscreenDirective } from './directives/toggle-fullscreen.directive';
import { CustomizerComponent } from './customizer/customizer.component';
import { NgbCollapseModule } from '@ng-bootstrap/ng-bootstrap';
import { UserNavbarComponent } from './user-navbar/user-navbar.component';
import { AllEventsComponent } from './all-events/all-events.component';
import { EventDetailsComponent } from './event-details/event-details.component';
import { CountdownTimerModule } from 'ngx-countdown-timer';
import { CountDown } from 'ng2-date-countdown';
import { FroalaEditorModule, FroalaViewModule } from 'angular-froala-wysiwyg';
import { OmisePaymentsComponent } from './omise-payments/omise-payments.component';
import { ScriptCustomComponent } from './script-custom/script-custom.component';
import { BookingComponent } from './booking/booking.component';
import { CreditCardComponent } from './credit-card/credit-card.component';
import { CreditCardDirectivesModule } from 'angular-cc-library';
import { QRCodeModule } from 'angularx-qrcode';
import { TicketViewComponent } from './ticket-view/ticket-view.component';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { OrderingComponent } from './ordering/ordering.component';
import { RegistryComponent } from './registry/registry.component';
import { RegisPersonComponent } from './registry/regis-person/regis-person.component';

@NgModule({
  exports: [
    CommonModule,
    FooterComponent,
    NavbarComponent,
    SidebarComponent,
    ToggleFullscreenDirective,
    NgbModule,
    CustomizerComponent,
    TranslateModule,
    UserNavbarComponent,
    AllEventsComponent,
    OmisePaymentsComponent,
    ScriptCustomComponent,
    BookingComponent,
    EventDetailsComponent,
    CreditCardComponent,
    TicketViewComponent,
    OrderingComponent,
    RegistryComponent
  ],
  imports: [
    QRCodeModule,
    FileUploadModule,
    CreditCardDirectivesModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    CommonModule,
    NgbModule,
    NgbCollapseModule,
    TranslateModule,
    CountdownTimerModule,
    FroalaEditorModule.forRoot(),
    FroalaViewModule.forRoot(),
    ArchwizardModule,
    ProgressSpinnerModule
  ],
  declarations: [
    FooterComponent,
    NavbarComponent,
    SidebarComponent,
    ToggleFullscreenDirective,
    CustomizerComponent,
    UserNavbarComponent,
    AllEventsComponent,
    EventDetailsComponent,
    CountDown,
    OmisePaymentsComponent,
    ScriptCustomComponent,
    BookingComponent,
    CreditCardComponent,
    TicketViewComponent,
    OrderingComponent,
    RegistryComponent,
    RegisPersonComponent
  ],
  bootstrap: [CreditCardComponent]
})
export class SharedModule {}
